var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefualtProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1966 34.2589C55.1966 38.2679 51.9466 41.5179 47.9376 41.5179C43.9286 41.5179 40.6787 38.2679 40.6787 34.2589C40.6787 30.2499 43.9286 27 47.9376 27C51.9466 27 55.1966 30.2499 55.1966 34.2589Z",
    stroke: "#CA1211",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 65.7148V57.3887C31 54.7826 32.4917 52.4001 34.9324 51.4867C38.2247 50.2545 43.7757 48.7773 47.9375 48.7773C52.187 48.7773 56.9025 50.3174 60.6202 51.5643C63.2212 52.4366 64.875 54.9146 64.875 57.658V65.7148",
    stroke: "#CA1211",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefualtProfile);
export default __webpack_public_path__ + "static/media/defualtProfile.a67d7968c98cbead29e6b251bad27d04.svg";
export { ForwardRef as ReactComponent };